import { render, staticRenderFns } from "./BlogEntrada.vue?vue&type=template&id=87a25296&"
import script from "./BlogEntrada.vue?vue&type=script&lang=js&"
export * from "./BlogEntrada.vue?vue&type=script&lang=js&"
import style0 from "./BlogEntrada.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports